// extracted by mini-css-extract-plugin
export default {"page":"Configuration_page__D9dDe","title":"Configuration_title__n8T-B"};